<template>
  <div id="app">
    <router-view/>
  </div>
</template>

<script>
import '../src/assets/css/font.css'

// app.js
import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'

export default {
  name: 'App',
   created(){


     if((navigator.userAgent.match(/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i))) {
                 window.location.href="https://m.westgenepharma.com";  //跳转到手机
            }else{
              console.log('pc')
               
            }
  }
}
</script>

<style>
body{
  font-family:"思源黑体","Microsoft YaHei";
  /* font-family: Source Han Sans CN; */
  /* font-family: "Hiragino Sans GB", "微软雅黑", "Microsoft JhengHei", "WenQuanYi Micro Hei", "Helvetica Neue", Verdana, Arial, Helvetica, sans-serif; */

}
/* html{
  height: 10rem;
} */

</style>



// WEBPACK FOOTER //
// src/App.vue